//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _willExport_item_item_patch from './willExport_item_item_patch';
export const willExport_item_item_patch = _willExport_item_item_patch;
export default {willExport_item_item_patch};

